if (window.Drupal === undefined) {
  window.Drupal = {
    t(string) {
      return string;
    }
  };
}

class drupalSettings {
  constructor() {
    if (window.drupalSettings !== undefined) {
      Object.assign(this, window.drupalSettings);
    } else {
      // Modify this object to provide credentials when not running within Drupal site.
      const defaultSettings = {
        path: {
          currentLanguage: "en"
        },
        regionMarket: {
          location: "GB"
        },
        ed_dashboard: {
          brand_name: process.env.REACT_APP_BRAND_NAME,
          allowed_shipping_countries: JSON.parse(
            process.env.REACT_APP_ALLOWED_SHIPPING_COUNTRIES
          ),
          top_ballot_markets: process.env.REACT_APP_TOP_BALLOT_MARKETS,
          recaptcha_site_key: process.env.REACT_APP_RECAPTCHA_KEY,
          loqate_api_key: process.env.REACT_APP_LOQATE_API_KEY,
          show_social_login_methods: process.env.REACT_APP_SOCIAL_LOGINS,
          ballot_intro: process.env.REACT_APP_BALLOT_INTRO,
          privacy_link: process.env.REACT_APP_PRIVACY_LINK,
          contact_link: process.env.REACT_APP_CONTACT_LINK,
          terms_and_conditions_link:
            process.env.REACT_APP_TERMS_AND_CONDITIONS_LINK,
          client_id: process.env.REACT_APP_CLIENT_ID,
          domain: process.env.REACT_APP_DOMAIN,
          database_connection_name:
            process.env.REACT_APP_DATABASE_CONNECTION_NAME,
          audience: process.env.REACT_APP_AUDIENCE,
          api_url: process.env.REACT_APP_API_URL,
          api_key: process.env.REACT_APP_API_KEY,
          stripe_key: process.env.REACT_APP_STRIPE_KEY,
          stripe_account_id: process.env.REACT_APP_STRIPE_ACCOUNT_ID,
          payment_enabled_markets: JSON.parse(
            process.env.REACT_APP_PAYMENT_ENABLED_MARKETS
          ),
          order_enabled_markets: JSON.parse(
            process.env.REACT_APP_ORDER_ENABLED_MARKETS
          ),
          ballot_enabled_markets: JSON.parse(
            process.env.REACT_APP_BALLOT_ENABLED_MARKETS
          ),
          country_list: JSON.parse(process.env.REACT_APP_COUNTRY_LIST),
          legal_drinking_ages: JSON.parse(
            process.env.REACT_APP_LEGAL_DRINKING_AGES
          ),
          default_legal_drinking_age:
            process.env.REACT_APP_DEFAULT_LEGAL_DRINKING_AGE,
          mandatory_privacy_opt_in_markets: JSON.parse(
            process.env.REACT_APP_MANDATORY_PRIVACY_OPT_IN_MARKETS
          ),
          exclusive_offers_enabled:
            process.env.REACT_APP_EXCLUSIVE_OFFERS_ENABLED
        }
      };

      Object.assign(this, defaultSettings);
    }
  }
}

// todo: rename class with uppercase
// eslint-disable-next-line new-cap
export default new drupalSettings();
